export default "__VITE_ASSET__CgNoB0xq__"